import { useSideBySideEditorContext } from '../contexts/SideBySideEditorContext';

export const useInsertAtCursor = () => {
  const { editor } = useSideBySideEditorContext();

  return (snippet: string) => {
    const thisEditor = editor.current;
    if (thisEditor) {
      const target = thisEditor.selection.getRange(); // either the cursor location or selected range
      const newRange = {
        ...target,
        end: { row: target.end.row, column: target.start.column + snippet.length },
      };
      thisEditor.session.replace(target, snippet);
      thisEditor.selection.setRange(newRange);
      thisEditor.focus();
    }
  };
};
